module.exports = __webpack_public_path__ + "img/png.fcc3c867.svg";